export const data = [
  {
    itemName: "ConvoServices Rides",
    itemCategory: "Luxury Transport Rides",
    itemLink: "https://broseey.github.io/CONVOSERVICES-SITE/",
    itemCopy:
      "A site I developed for a Transport&Security company,that operates in adoekiti,Nigeria. Currently not on-board. Dealt with problem of ordering transport for events in the state, making rides available for events(like convocations/Ceremonies involving Luxury cars/ prioritized comfort)",
    itemImg: require("./assets/project-images/convoservice.jpg"),
  },

  {
    itemName: "Royale RealEstates",
    itemCategory: "Luxury Real Estate Services",
    itemLink: "https://broseey.github.io/REAL_ESTATE_PROJECT",
    itemCopy:
      "Embark on a journey to find your dream home with Royale RealEstates. We specialize in luxury real estate services, offering exquisite properties tailored to your lifestyle. Experience the epitome of elegance and comfort in every home we present.",
    itemImg: require("./assets/project-images/royaleestate.png"),
  },

  {
    itemName: "Emmax Portfolio",
    itemCategory: "Design Portfolio Showcase",
    itemLink: "https://broseey.github.io/Emmax-Portfolio/",
    itemCopy:
      "Explore the creative universe of Emmax, a visionary designer. This portfolio showcases a diverse range of design projects, from web development to graphic design. Experience the fusion of innovation and aesthetics in Emmax's portfolio.",
    itemImg: require("./assets/project-images/emmax.png"),
  },

  {
    itemName: "Aesthetic Photography Gallery",
    itemCategory: "Artistic Photography Showcase",
    itemLink: "https://broseey.github.io/ArtGallery/",
    itemCopy:
      "Immerse yourself in the world of aesthetics through our carefully curated photography gallery. Discover captivating visuals and artistic expressions that tell unique stories. Explore the beauty of moments frozen in time with our Aesthetic Photography Gallery.",
    itemImg: require("./assets/project-images/GalleryPic.jpg"),
  },

  {
    itemName: "Favourite Musician Catalogue",
    itemCategory: "Musician Discography Collection",
    itemLink: "https://broseey.github.io/MUSICIAN-FAVE/",
    itemCopy:
      "Dive into the world of Brose's favorite musician with our comprehensive catalogue. Explore their discography, relive timeless hits, and discover hidden gems. Immerse yourself in the soundscapes that have defined moments in music history.",
    itemImg: require("./assets/project-images/MusicianCatalogue.jpg"),
  },

  {
    itemName: "Practice Project Highlight",
    itemCategory: "Personal Project Showcase",
    itemLink: "https://broseey.github.io/fun-projects-hub/",
    itemCopy:
      ' "Practice creates ease", i can say this evidently. Here are a good number of quick side practice project I undertook, in order to enable some nice animation functionalities, like trailing cursors and all, just explore! check out various practice components available for reuse also to other developers',
    itemImg: require("./assets/project-images/QuickPracticeProject.png"),
  },
  {
    itemName: "Featured works showcase",
    itemCategory: "Project Showcase",
    itemLink: "https://broseey.github.io/Featured-Model/",
    itemCopy:
      "A site with nice effect is needed to showcase beautiful art, or an artist carefully taken pictures, an elegant site with cool parallax effect on Showcased Images serves such purpose ",
    itemImg: require("./assets/project-images/WorkShowcase.png"),
  },
  {
    itemName: "Showcase Portfolio Demo",
    itemCategory: "Client's Demo showcase",
    itemLink: "https://broseey.github.io/PortfolioMake1/",
    itemCopy:
      "A demo site for client to get an idea of their taste in the flow of nice scroll effects, Recreated getting Design inspiration from KD(keven Devenport)",
    itemImg: require("./assets/project-images/PortfolioShow.png"),
  },
  {
    itemName: "Showcase Portfolio Demo",
    itemCategory: "Client's Demo showcase",
    itemLink: "https://broseey.github.io/PortfolioMake2/work.html",
    itemCopy:
      "A complete demo site for client to make their preference for similar look",
    itemImg: require("./assets/project-images/PortfolioPrefernce.png"),
  },
  {
    itemName: "Showcase Portfolio Demo",
    itemCategory: "Client's Demo showcase",
    itemLink: "https://broseey.github.io/MY-JS-INTRO/",
    itemCopy:
      "This project marks my introduction to JavaScript, serving as the foundation for my exploration in the language. It's the first step in my journey toward mastering JavaScript development, making it a fitting addition to my portfolio.",
    itemImg: require("./assets/project-images/JSPractice.jpg"),
  },
];
